import React from 'react';
import MUIMarquee from '../primitives/Marquee';
import { Section } from '../layout/Section';

/**
 * Marquee band — used in Act II (Confirmation) directly after Hero.
 *
 * Typography: matches the Horrenmaker.nl wordmark (Bowlby One). The text
 * is sized via clamp() so it consumes ~70% of the band's natural height
 * (py-3 padding + ~52px cap height on desktop ≈ 76px banner).
 */
export default function MarqueeBlock({ tone = 'leaf', rhythm = 'tight', items = [] }) {
  return (
    <Section tone={tone} rhythm="none" className="py-3" data-testid="trust-bar">
      <MUIMarquee speed={55} fade={false} className="font-bowlby uppercase text-white">
        {[...items.map((s, i) => ({ s, k: `a-${i}-${s}` })),
          ...items.map((s, i) => ({ s, k: `b-${i}-${s}` }))].map(({ s, k }) => (
          <span
            key={k}
            className="inline-flex items-center gap-12 whitespace-nowrap pr-12"
            style={{
              fontSize: 'clamp(28px, 4.2vw, 56px)',
              lineHeight: 1,
              letterSpacing: '0.01em',
            }}
          >
            {s}
            <span className="opacity-55 pl-12">·</span>
          </span>
        ))}
      </MUIMarquee>
    </Section>
  );
}
